import { Reconciliation, ReconciliationRelationStatus } from '~/types/reconciliation';

export const filterVerifiedReconciliations = (reconciliations?: Reconciliation[]) => {
  return reconciliations?.filter((el) => el.status === ReconciliationRelationStatus.VERIFIED) || [];
};

export const hasVerifiedReconciliation = (reconciliations?: Reconciliation[]) => {
  return reconciliations?.some((item) => item.status === ReconciliationRelationStatus.VERIFIED);
};
